import { createAsyncThunk } from '@reduxjs/toolkit';
import { projectLayoutApi } from 'container/projectLayoutApi';
import { ProjectLayoutModel } from 'api/dto/ProjectLayout.dto';
import { STORE_NAME } from 'reduxStore/project/initialState';
import { selectCurrentProjectId } from 'reduxStore/project/projectSelector';
import { serializeError } from 'shared/utils/redux';

export const fetchProjectLayout = createAsyncThunk(
  `${STORE_NAME}/fetchProjectLayout`,
  ({ projectId }: { projectId: number }) => {
    return projectLayoutApi.fetch(projectId);
  },
  { serializeError },
);

export const saveProjectLayout = createAsyncThunk(
  `${STORE_NAME}/saveProjectLayout`,
  ({ layout }: { layout: ProjectLayoutModel }, { getState }) => {
    const projectId = selectCurrentProjectId(getState());
    return projectLayoutApi.save(projectId, layout);
  },
  { serializeError },
);
